export const DraftSwitcher = {
  Input: {
    checked: ({ state }) => state.draft
  },
  SwitchField: {},
  Caption: {
    padding: '0',
    opacity: '.65',
    color: 'inactive',
    text: '{{ common.state.draft | polyglot }}'
  },
  extends: 'SwitchFieldWithCaption',
  onChange: (ev, el, s) => {
    s.update({
      draft: !s.draft
    })
  }
}
